import api from 'api'

export const fetchDevolutives = async (projectId) => {
  const { data } = await api.get(`/project/${projectId}/devolutive`)

  return data
}
